import { effect, Injectable } from '@angular/core';
import { DataLayerType } from '../models/data-layer-type';
import { DataLayer } from '../models/data-layer';
import { InitializationHandler } from './initialization-handler';
import { RoutingService } from '../services/routing.service';

@Injectable({
  providedIn: 'root',
})
export class AtlasHandler extends InitializationHandler {
  initialized = false;

  /**
   * Sets the initial layer by excluding empty layers from the available layer types.
   * The method selects the first non-empty layer based on grouped types in the layer store
   * and updates the global store's selected type and layer, then sets permissions.
   *
   * @return {void} This method does not return a value.
   */
  setInitialLayerExcludeEmpty(): void {
    const types =
      this.layerTypeStore.polygonLayers() || this.layerTypeStore.asArray();
    const layersByType = this.layerStore.groupedByType();
    let type: DataLayerType | undefined;
    let layer: DataLayer | undefined;
    let idx = 0;

    while (layer === undefined && idx < this.layerTypeStore.count()) {
      type = types[idx];
      if (type && layersByType[type._id] && layersByType[type._id].length) {
        layer = layersByType[type._id][0];
      }
      idx++;
    }

    setTimeout(() => {
      if (type) this.globalStore.setSelectedType(type);
      if (layer) this.globalStore.setSelectedLayer(layer);
      this.permissionStore.setPermissions();
    });
  }

  /**
   * Specific initialization logic for the Atlas
   */
  performInitialization(): void {
    if (!this.initialized && this.areStoresInitialized()) {
      this.initialized = true;
      this.layerTypeStore.reduceStoreByAvailableLayers(
        this.layerStore.getAvailableTypeIds()
      );
      this._storesInitialized.set(true);
      this._activeCommune.set(this.globalStore.activeCommune());

      this.setInitialLayerExcludeEmpty();
      this.routingService.initiateAtlasSubscriptions();
    }
  }
}
